/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type UniversalSearchParams = {
/**
 * @minLength 1
 * @maxLength 200
 */
q: string;
/**
 * @minimum 1
 * @maximum 25
 */
limit?: number;
types?: ('projects' | 'jobs' | 'candidates' | 'sequences' | 'searches' | 'tasks' | 'snippets' | 'presets')[] | null;
};
